import React, { FC } from 'react';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { Form } from '@ant-design/compatible';
import OWRadio from '../static_visual_radio_input/StaticVisualRadioInput';
import { connect } from 'react-redux';

const WOUserLocation: FC<any> = ({
	formData,
	handleUserLocation,
	userLocation,
	form,
	companyConfig,
}): React.ReactElement => {
	const { getFieldDecorator } = form;

	return (
		<div key={0} className="newWorkOrderWizardPage__section">
			<h3 className="newWorkOrderWizardPage__title">
				It looks like you're at {userLocation.name}.
			</h3>
			<h3 className="newWorkOrderWizardPage__title">Is that where you need service?</h3>
			{nullSafeGet('config.newWorkOrder.step1.instructions', companyConfig) &&
			nullSafeGet('config.newWorkOrder.step1.instructions', companyConfig) !==
				"Tell us a bit about the issue you'd like addressed." ? (
				<h5>{nullSafeGet('config.newWorkOrder.step1.instructions', companyConfig)}</h5>
			) : null}
			<Form.Item style={{ width: '100%' }}>
				{getFieldDecorator(`isUserLocation`, {
					initialValue: nullSafeGet('isUserLocation', formData),
				})(
					<OWRadio
						fieldName="isUserLocation"
						onChange={handleUserLocation}
						onClick={handleUserLocation}
						renderRecord={(location) => location.name}
						records={{
							1: { id: 1, name: "Yes, that's right." },
							2: { id: 2, name: 'No, somewhere else.' },
						}}
						sorter={(records) => records.sort((a, b) => (a.id > b.id ? 1 : -1))}
					/>
				)}
			</Form.Item>
		</div>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config.detail,
});

export default connect(mapStateToProps)(WOUserLocation);
